import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useForm from 'dpl/shared/form/hooks/useForm';
import Input from 'dpl/form/components/Input';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import { AUTH_PATHS } from 'dpl/shared/constants/urls';
import { pushParams } from 'dpl/actions/query_params';
import { sendAnalyticsIdentify } from 'dpl/util/analytics';
import FormContext from 'dpl/shared/form/utils/context';

export default function LoginForm({
  buttonText,
  headerText,
  onSuccessfulAuth
}) {
  const { login } = useCurrentUser();
  const { isSubmitting, handleSubmission, contextValue, isValid, reset } =
    useForm({
      onSubmit: formState => login({ body: { user: formState } }),
      mapFormStateToValidationSchema: () => ({
        email: CONSTRAINT_TYPES.TEXT,
        password: CONSTRAINT_TYPES.PASSWORD
      })
    });

  useEffect(() => {
    reset();
  }, []);

  const dispatch = useDispatch();

  function handleForgotPasswordClick(e) {
    e.preventDefault();
    return dispatch(
      pushParams(
        {
          direct_signup: SIGNUP_FORM_TYPES.FORGOT_PASSWORD
        },
        { hash: true }
      )
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const submission = await handleSubmission();
    if (submission.response.ok) {
      sendAnalyticsIdentify({ userId: submission.data.data.user_id });
      onSuccessfulAuth();
    }
  }

  return (
    <div className="BuyerAccountLoginForm">
      <h5 className="tc">{headerText}</h5>
      <FormContext.Provider value={contextValue}>
        <form className="pt10 pb12" onSubmit={handleSubmit}>
          <div className="mb6">
            <Input
              name="email"
              label="Email"
              placeholder="jane@highpeaksfarm.com"
              autoCapitalize="none"
            />
          </div>
          <div className="mb6">
            <Input
              name="password"
              label="Password"
              type="password"
              autoCapitalize="none"
            />
            <a
              className="f2 mid-gray"
              href={AUTH_PATHS.FORGOT_PASSWORD}
              onClick={handleForgotPasswordClick}
            >
              Forgot password
            </a>
          </div>
          <button
            type="submit"
            disabled={isSubmitting || !isValid}
            className="button button--primary pv2 w-100"
          >
            {buttonText}
          </button>
        </form>
      </FormContext.Provider>
    </div>
  );
}

LoginForm.propTypes = {
  buttonText: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  onSuccessfulAuth: PropTypes.func.isRequired
};
